module.exports = __webpack_public_path__ + "static/media/striped_bar_SMAP_tall.564d9d2d.svg";